import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { GlobalContext } from "../Context";
import LoadingWheel from "../LoadingWheel";

const ImpersonateUserModal = ({ open, onClose }) => {
  const { firebaseState, setUserStateEmail } = useContext(GlobalContext);

  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fetchedUser, setFetchedUser] = useState();
  const [message, setMessage] = useState();

  const handleText = (event) => {
    setSearch(event.target.value);
  };

  const getUser = async () => {
    setIsLoading(true);
    try {
      const res = await firebaseState.getProfileByEmail(search);
      if (!res) {
        setMessage(`Cannot find user for email ${search}`);
      } else {
        setFetchedUser(res);
      }
    } catch (error) {
      console.error("Error fetching user", error);
      setMessage("Error fetching user, please try again");
    }

    setIsLoading(false);
  };

  const onConfirm = () => {
    setUserStateEmail(fetchedUser.email);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Impersonate User</DialogTitle>
      <DialogContent sx={{ width: "35rem" }}>
        {isLoading ? (
          <LoadingWheel width={4} />
        ) : !fetchedUser ? (
          <Box>
            <Typography>
              Search for a user by their email to impersonate
            </Typography>
            <TextField
              sx={{ m: "1rem 0" }}
              value={search}
              onChange={handleText}
            />
            <Button
              variant="contained"
              onClick={getUser}
              sx={{ display: "block" }}>
              Search
            </Button>
            {message && <Typography color="error">{message}</Typography>}
          </Box>
        ) : (
          <Box>
            <Typography>
              Found user{" "}
              <b>
                {fetchedUser.name} {fetchedUser.lastName}
              </b>
            </Typography>
            <Typography>{`Email: ${fetchedUser.email}`}</Typography>
            <Typography>{`User ID: ${fetchedUser.id}`}</Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}>
              <Typography>Confirm that you want to impersonate</Typography>
              <Button
                variant="contained"
                sx={{ ml: "0.5rem" }}
                onClick={onConfirm}>
                Confirm
              </Button>
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImpersonateUserModal;
